import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import moment from 'moment';
import { getWeekdays } from 'helpers/datetime';
import * as selectors from '../../selectors';
import DaysSelector from './DaysSelector';
import DaysSelectorControlBtn from './DaysSelectorControlBtn';
import Weeks from './Weeks';
import styles from './DailyGlucoseProfile.pcss';
const DailyGlucoseProfile = ({ patient, phiSet, phiSetDocumentId, isInProgress, onDatesChange })=>{
    useStyles(styles);
    const dailyRecordsPaginatedByMonth = useSelector(selectors.dailyRecordsPaginatedByMonth);
    let date;
    if (dailyRecordsPaginatedByMonth && dailyRecordsPaginatedByMonth.length > 0) {
        date = moment(dailyRecordsPaginatedByMonth[0].date).format('MMMM YYYY');
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.root,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.header,
                children: /*#__PURE__*/ _jsx(DaysSelectorControlBtn, {
                    date: date,
                    patient: patient,
                    phiSet: phiSet,
                    phiSetDocumentId: phiSetDocumentId
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.weekdays,
                children: getWeekdays().map((weekday)=>/*#__PURE__*/ _jsx("div", {
                        className: styles.weekday,
                        children: moment.utc().startOf('isoWeek').add(weekday, 'd').format('dddd')
                    }, `${weekday}-weekday-header`))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row flex-nowrap",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: cn('col-auto', styles.daysWrapper),
                        children: /*#__PURE__*/ _jsx(Weeks, {
                            isInProgress: isInProgress
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn('col', styles.content),
                        children: /*#__PURE__*/ _jsx(DaysSelector, {
                            isInProgress: isInProgress,
                            onDatesChange: onDatesChange
                        })
                    })
                ]
            })
        ]
    });
};
export default DailyGlucoseProfile;
